import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './index.scss';

const Page = (props) => {
  return (
    <div
      className={classNames(
        'Page',
        { 'Page--fluid': props.fluid },
        props.className
      )}
    >
      {props.children}
    </div>
  );
};

Page.defaultProps = {
  animate: true,
  fluid: false
};

Page.propTypes = {
  animate: PropTypes.bool,
  className: PropTypes.string,
  fluid: PropTypes.bool
};

export default Page;
